import { render } from "./RhAccordion.vue?vue&type=template&id=1a25ce84&scoped=true&ts=true"
import script from "./RhAccordion.vue?vue&type=script&lang=ts"
export * from "./RhAccordion.vue?vue&type=script&lang=ts"

import "./RhAccordion.vue?vue&type=style&index=0&id=1a25ce84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a25ce84"]])

export default __exports__